/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Class of data exported by this route.
 */
export const DataSource = {
  ProductTelemetry: "product_telemetry",
  RiskFindings: "risk_findings",
  ToolCallLogs: "tool_call_logs",
} as const;
/**
 * Class of data exported by this route.
 */
export type DataSource = ClosedEnum<typeof DataSource>;

/**
 * Form for creating the selected data source's export route.
 */
export type CreateDataExportRouteForm = {
  /**
   * Class of data exported by this route.
   */
  dataSource: DataSource;
  /**
   * Whether the route is enabled.
   */
  enabled?: boolean | undefined;
  /**
   * OTEL destination configured on this route. Required when enabled.
   */
  otelDestinationId?: string | undefined;
};

/** @internal */
export const DataSource$outboundSchema: z.ZodMiniEnum<typeof DataSource> = z
  .enum(DataSource);

/** @internal */
export type CreateDataExportRouteForm$Outbound = {
  data_source: string;
  enabled: boolean;
  otel_destination_id?: string | undefined;
};

/** @internal */
export const CreateDataExportRouteForm$outboundSchema: z.ZodMiniType<
  CreateDataExportRouteForm$Outbound,
  CreateDataExportRouteForm
> = z.pipe(
  z.object({
    dataSource: DataSource$outboundSchema,
    enabled: z._default(z.boolean(), true),
    otelDestinationId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      dataSource: "data_source",
      otelDestinationId: "otel_destination_id",
    });
  }),
);

export function createDataExportRouteFormToJSON(
  createDataExportRouteForm: CreateDataExportRouteForm,
): string {
  return JSON.stringify(
    CreateDataExportRouteForm$outboundSchema.parse(createDataExportRouteForm),
  );
}
